<template>
  <div class="page-parsing-link">
    <section class="loading-rtc">
      <div class="loading-animation"></div>
      <span>{{$t('home.ResolvingInviteLink')}}...</span>
    </section>
  </div>
</template>

<script>
import Observer from '@/utils/observer'
import { mapActions } from 'vuex'
import { PAGE_NAME } from '@/utils/constant'
import { Modal } from 'ant-design-vue'
import lottie from 'lottie-web'

let loadingAnimation

export default {
  name: 'ParsingLink',

  mounted () {
    loadingAnimation = lottie.loadAnimation({
      container: document.querySelector('.loading-animation'),
      renderer: 'svg',
      loop: true,
      autoplay: true,
      path: './lottie/talk-loading.json'
    })

    const { conferenceId } = this.$route.params
    // mqtt登录成功后开始加入
    Observer.$on('mqtt-logon', () => {
      this.joinConference(conferenceId).catch((err) => {
        this.$router.replace({
          name: PAGE_NAME.Home,
          query: { conferenceId }
        })
        if (err && err.code === 22009) {
          Modal.info({
            content: this.$t('home.NotJoinIsFull'),
            width: '460px',
            centered: true,
            class: 'confirm-exit',
            closable: true,
            okText: this.$t('calling.GotIt')
          })
        }
      })
    })
  },

  beforeDestroy() {
    loadingAnimation && loadingAnimation.destroy()
  },

  methods: {
    ...mapActions('coc', ['joinConference'])
  }
}
</script>

<style lang="scss" scoped>
.page-parsing-link {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;

  .loading-rtc {
    position: absolute;
    text-align: center;

    .loading-animation {
      width: 199px;
      height: 198px;
    }

    > span {
      font-size: 16px;
      color: #999B9F;
      line-height: 22px;
    }
  }
}
</style>
